// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    AdminAccount,
    AdminAccountFromJSON,
    AdminAccountToJSON,
    AdminResetPasswordRequest,
    AdminResetPasswordRequestFromJSON,
    AdminResetPasswordRequestToJSON,
    CreateAccount,
    CreateAccountFromJSON,
    CreateAccountToJSON,
    MarkAsSpamRequest,
    MarkAsSpamRequestFromJSON,
    MarkAsSpamRequestToJSON,
    NewAccount,
    NewAccountFromJSON,
    NewAccountToJSON,
  } from '../models';

      export interface CreateAccountRequest {
        createAccount?: CreateAccount;
      }

      export interface GetAccountsRequest {
        organisationId?: number;
        includeDeleted?: boolean;
      }

      export interface MarkAccountAsSpamRequest {
        accountId: number;
        markAsSpamRequest?: MarkAsSpamRequest;
      }

      export interface ResetAccountPasswordRequest {
        accountId: number;
        adminResetPasswordRequest?: AdminResetPasswordRequest;
      }


/**
* no description
*/
export interface AdminApi {
    /**
      * Create a new account
    */
    createAccount(requestParameters: CreateAccountRequest): Promise<NewAccount>
    /**
      * Get a list of accounts
    */
    getAccounts(requestParameters: GetAccountsRequest): Promise<Array<AdminAccount>>
    /**
      * Mark the account as spam
    */
    markAccountAsSpam(requestParameters: MarkAccountAsSpamRequest): Promise<void>
    /**
      * Reset the password of the given account id
    */
    resetAccountPassword(requestParameters: ResetAccountPasswordRequest): Promise<void>
}

  /**
  * no description
  */
  export class AdminApiImpl extends runtime.BaseAPI implements AdminApi {

    /**
      * Create a new account
    */
    async createAccountRaw(requestParameters: CreateAccountRequest): Promise<runtime.ApiResponse<NewAccount>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/admin/accounts`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: CreateAccountToJSON(requestParameters.createAccount),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => NewAccountFromJSON(jsonValue));
      }

      /**
        * Create a new account
      */
      async createAccount(requestParameters: CreateAccountRequest): Promise<NewAccount> {
        const response = await this.createAccountRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a list of accounts
    */
    async getAccountsRaw(requestParameters: GetAccountsRequest): Promise<runtime.ApiResponse<Array<AdminAccount>>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.organisationId !== undefined) {
              queryParameters['organisationId'] = requestParameters.organisationId;
          }

          if (requestParameters.includeDeleted !== undefined) {
              queryParameters['includeDeleted'] = requestParameters.includeDeleted;
          }

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/accounts`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminAccountFromJSON));
      }

      /**
        * Get a list of accounts
      */
      async getAccounts(requestParameters: GetAccountsRequest): Promise<Array<AdminAccount>> {
        const response = await this.getAccountsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Mark the account as spam
    */
    async markAccountAsSpamRaw(requestParameters: MarkAccountAsSpamRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
          throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling markAccountAsSpam.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/admin/accounts/{accountId}/mark-as-spam`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
              body: MarkAsSpamRequestToJSON(requestParameters.markAsSpamRequest),
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Mark the account as spam
      */
      async markAccountAsSpam(requestParameters: MarkAccountAsSpamRequest): Promise<void> {
        await this.markAccountAsSpamRaw(requestParameters);
      }

    /**
      * Reset the password of the given account id
    */
    async resetAccountPasswordRaw(requestParameters: ResetAccountPasswordRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
          throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling resetAccountPassword.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/admin/accounts/{accountId}/reset-password`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
              body: AdminResetPasswordRequestToJSON(requestParameters.adminResetPasswordRequest),
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Reset the password of the given account id
      */
      async resetAccountPassword(requestParameters: ResetAccountPasswordRequest): Promise<void> {
        await this.resetAccountPasswordRaw(requestParameters);
      }

    }
